import { EnumFeatureFlagName } from '@blank/api'
import { useAuthenticatedUserCorporateQuery } from 'modules/auth/queries/useAuthenticatedUserCorporateQuery'
import { useBanner } from 'modules/common/hooks/useBanner'
import { EnumBannerKey } from 'modules/common/types/banner'
import { useFeatureFlagQuery } from 'modules/corporate/queries/useFeatureFlagQuery'

export const useCorporateActiveBanner = () => {
  const { data } = useAuthenticatedUserCorporateQuery()
  const activeBanner = data?.corporate?.activeBanner

  const { data: activeBannerFeatureFlag } = useFeatureFlagQuery(
    EnumFeatureFlagName.IN_APP_BANNER_ENABLED,
    {
      enabled: Boolean(data?.corporate?.id),
    }
  )

  const { isBannerToBeDisplayed } = useBanner({
    bannerKey: EnumBannerKey.CORPORATE_ACTIVE,
    displayCondition:
      Boolean(activeBanner) && Boolean(activeBannerFeatureFlag?.body?.enabled),
  })

  return {
    activeBanner,
    isBannerToBeDisplayed,
  }
}
